<template>
    <div>
        <div class="box">
            <ul>
                <li v-for="(item,index) in lists" :key="item.src" :class="{active:item.isActive}"
                @mouseover="handleOver(item,index)"
                @mousemove="handleMove"
                @mouseout="handleOut"
                >
                    <img :src="item.src">
                </li>
            </ul>
        </div>
        <div class="big"  v-show="show" ref="myBig">
            <div v-show="bigShow"></div>            
        </div>
    </div>
</template>
<script>
export default {
    name:'Navs',
    data(){
        return{
            show:false,
            bigShow:false,            
            lists:[
                {src:require('./assets/lesson5/shirt_1.jpg'), isActive:false},
                {src:require('./assets/lesson5/shirt_2.jpg'), isActive:false},
                {src:require('./assets/lesson5/shirt_3.jpg'), isActive:false},
                {src:require('./assets/lesson5/shirt_4.jpg'), isActive:false},
            ],
            bigList:[
                {src:require('./assets/lesson5/shirt_1_big.jpg')},
                {src:require('./assets/lesson5/shirt_2_big.jpg')},
                {src:require('./assets/lesson5/shirt_3_big.jpg')},
                {src:require('./assets/lesson5/shirt_4_big.jpg')},
            ]
        }
    },    
    methods:{
        handleOver(item,index){
            var oImg=document.createElement('img');
            var img= new Image();
            img.src=oImg.src=this.bigList[index].src;
            this.$refs.myBig.appendChild(oImg);
            this.lists[index].isActive=true;
            this.show=this.bigShow=true;
            img.complete ? this.bigShow=false : ''
        },
        handleMove(){
            var newWidth= document.documentElement.offsetWidth - event.clientX;
            this.$refs.myBig.style.top=event.clientY + 20 + 'px';
            this.$refs.myBig.style.left = (newWidth < this.$refs.myBig.offsetWidth + 10 ? event.clientX - this.$refs.myBig.offsetWidth - 10 : event.clientX + 10) + 'px';
        },
        handleOut(){
            this.show=false;
            this.$refs.myBig.removeChild(this.$refs.myBig.lastChild)
        }
    }
}
</script>
<style>
html,body{
    overflow: hidden;
}
body,div,ul,li{
    margin: 0;
    padding: 0;
}
.box ul{
    width: 768px;
    height: 172px;
    list-style-type: none;
    margin: 10px auto;
}
.box li{
    float: left;
    width: 170px;
    height: 170px;
    cursor: pointer;
    border: 1px solid #ddd;
    margin-right: 0 10px;
}
.box li.active{
    border:1px solid #a10000;
}
.box li img{
    width: 170px;
    height: 170px;
    visibility: top;
}
.big{
    position: absolute;
    width: 400px;
    height: 400px;
    border: 2px solid #ddd;
    
}
.big div{
    position: absolute;
    top:0;
    left: 0;
    width: 400px;
    height: 400px;
    opacity: 0.5;
    filter: alpha(opacity=50);
    background: #fff rul('./assets/lesson5/loading.gif') 50% 50% no-repeat;
}
</style>
